module.exports = __webpack_public_path__ + "img/Sarvi.94241484.png";